import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=3100f826&"
import script from "./ModalBox.vue?vue&type=script&lang=js&"
export * from "./ModalBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports